import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Platforms } from "@/components/Platforms";
import { Features } from "@/components/Features";
import { Demographics } from "@/components/Demographics";
import { Testimonials } from "@/components/Testimonials";
import { Footer } from "@/components/Footer";
import { FloatingContact } from "@/components/FloatingContact";

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <div className="App min-h-screen bg-white dark:bg-slate-950 font-body text-slate-900 dark:text-slate-100 antialiased transition-colors duration-300">
          <Navbar />
          <main>
            <Hero />
            <Platforms />
            <Features />
            <Demographics />
            <Testimonials />
          </main>
          <Footer />
          <FloatingContact />
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
